import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';

import ErrorFallback from 'components/error-fallback';

import { AuthProvider } from './auth';
import { UserProvider } from './user';
import { FetchProvider } from './fetch';

function Context({ children }) {
  return (
    <React.StrictMode>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Router>
          <HelmetProvider>
            <AuthProvider>
              <FetchProvider>
                <UserProvider>{children}</UserProvider>
              </FetchProvider>
            </AuthProvider>
          </HelmetProvider>
        </Router>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

Context.propTypes = {
  children: PropTypes.node,
};

Context.defaultProps = {
  children: null,
};

export default Context;
